import Swiper from "swiper";
import { Navigation } from "swiper/modules";

let isAnimationRunning = false;
let typingTimeoutIds = [];

export const initializeAppScripts = () => {
  // ======= Mobile Menu =======
  const mobileMenuBtn = document.getElementById("mobileMenuBtn");
  const mobileMenu = document.getElementById("mobileMenu");
  const closeMobileMenu = document.getElementById("closeMobileMenu");
  const menuOverlay = document.getElementById("menuOverlay");

  function openMenu() {
    mobileMenu?.classList.add("open");
    menuOverlay?.classList.add("active");
  }

  function closeMenu() {
    mobileMenu?.classList.remove("open");
    menuOverlay?.classList.remove("active");
  }

  mobileMenuBtn?.addEventListener("click", openMenu);
  closeMobileMenu?.addEventListener("click", closeMenu);
  menuOverlay?.addEventListener("click", closeMenu);

  // ======= Mobile Sub Menu =======
  const mobileSubMenus = document.querySelectorAll(".mobile-sub-menu");

  mobileSubMenus.forEach((subMenu) => {
    const trigger = subMenu.querySelector(".our-text");
    if (trigger) {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        mobileSubMenus.forEach((menu) => {
          if (menu !== subMenu) menu.classList.remove("active");
        });

        subMenu.classList.toggle("active");
      });
    }
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".mobile-sub-menu")) {
      mobileSubMenus.forEach((menu) => {
        menu.classList.remove("active");
      });
    }
  });

  // ======= Hero Typing Animation =======
  // Prevent multiple animations from running
  if (!isAnimationRunning) {
    const heroTexts = [
      "Mobile App Development",
      "Web Development",
      "UI/UX Design",
      "API Development",
      "E-Commerce Development",
      "CRM Development",
      "Cloud Solutions",
      "Zoho",
      "Development Support",
    ];
    let heroTextIndex = 0;

    const heroAnimatedText = document.getElementById("hero-animated-text");
    if (!heroAnimatedText) return;

    isAnimationRunning = true;
    const TYPING_SPEED = 100;
    const DELETING_SPEED = 50;
    const PAUSE_DURATION = 2000;

    function clearAllTimeouts() {
      typingTimeoutIds.forEach(id => clearTimeout(id));
      typingTimeoutIds = [];
    }

    function typeText(text, el, cb) {
      el.textContent = "";
      let i = 0;
      function type() {
        if (i < text.length) {
          el.textContent += text.charAt(i);
          i++;
          const timeoutId = setTimeout(type, TYPING_SPEED);
          typingTimeoutIds.push(timeoutId);
        } else if (cb) {
          const timeoutId = setTimeout(cb, PAUSE_DURATION);
          typingTimeoutIds.push(timeoutId);
        }
      }
      type();
    }

    function deleteText(el, cb) {
      let text = el.textContent;
      function deleteChar() {
        if (text.length > 0) {
          text = text.slice(0, -1);
          el.textContent = text;
          const timeoutId = setTimeout(deleteChar, DELETING_SPEED);
          typingTimeoutIds.push(timeoutId);
        } else if (cb) {
          const timeoutId = setTimeout(cb, 500);
          typingTimeoutIds.push(timeoutId);
        }
      }
      deleteChar();
    }

    function startTypingLoop() {
      if (!heroAnimatedText) {
        isAnimationRunning = false;
        return;
      }
      typeText(heroTexts[heroTextIndex], heroAnimatedText, () => {
        const timeoutId = setTimeout(() => {
          deleteText(heroAnimatedText, () => {
            heroTextIndex = (heroTextIndex + 1) % heroTexts.length;
            startTypingLoop();
          });
        }, 1000);
        typingTimeoutIds.push(timeoutId);
      });
    }

    // Clear any existing timeouts before starting
    clearAllTimeouts();
    startTypingLoop();
  }

  // ======= Sticky Navbar =======
  // Note: Scroll handler is now managed by Header component using React hooks
  // This code is kept for backward compatibility
  const navbar = document.querySelector(".custom-navbar");
  if (navbar && !navbar.hasAttribute("data-scroll-handler")) {
    navbar.setAttribute("data-scroll-handler", "true");
    const handleScroll = function () {
      if (window.scrollY > 10) navbar?.classList.add("scrolled");
      else navbar?.classList.remove("scrolled");
    };
    handleScroll(); // Check initial state
    window.addEventListener("scroll", handleScroll);
  }

  // ======= Tabs =======
  // Note: Portfolio filtering is now handled by React state in Portfolio_home.jsx
  // This code is kept for backward compatibility but only runs if old grid elements exist
  const allGrid = document.getElementById("all-grid");
  const appGrid = document.getElementById("app-grid");
  const webGrid = document.getElementById("web-grid");

  // Only run if the old grid elements exist (backward compatibility)
  if (allGrid || appGrid || webGrid) {
    const tabBtns = document.querySelectorAll(".tab-btn[data-filter]");

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        tabBtns.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        const filter = btn.dataset.filter;

        if (allGrid) allGrid.style.display = "none";
        if (appGrid) appGrid.style.display = "none";
        if (webGrid) webGrid.style.display = "none";

        let gridToShow;
        if (filter === "all") gridToShow = allGrid;
        else if (filter === "app") gridToShow = appGrid;
        else if (filter === "web") gridToShow = webGrid;

        if (gridToShow) {
          gridToShow.style.display = "";
          const cards = gridToShow.querySelectorAll(".card");
          cards.forEach((card) => {
            card.style.animation = "none";
            void card.offsetHeight; // Force reflow
            card.style.animation = "tabani 1s forwards";
          });
        }
      });
    });
  }

  // ======= Popup =======
  const popup = document.getElementById("popup");
  const popupClose = document.getElementById("popup-close");

  const showPopup = () => {
    if (!popup) return; // Check if popup exists
    popup.style.display = "flex";
    popup.classList.add("show");
    popup.classList.remove("hide");
    // Disable body scroll
    document.body.style.overflow = "hidden";
  };

  const hidePopup = () => {
    if (!popup) return; // Check if popup exists
    popup.classList.remove("show");
    popup.classList.add("hide");
    // Enable body scroll
    document.body.style.overflow = "";
    setTimeout(() => {
      if (!popup) return; // Check again in timeout
      popup.classList.remove("hide");
      popup.style.display = "none";
    }, 250);
  };

  if (popup) {
    // Event delegation: Listen for clicks on all "Get a Quote" buttons
    document.addEventListener("click", function (e) {
      const target = e.target;

      // Find the closest button or link element
      const buttonOrLink = target.closest('a, button');
      const elementToCheck = buttonOrLink || target;

      // Get text content and normalize it
      const textContent = elementToCheck.textContent?.trim() || "";

      // Check if clicked element or its parent contains "Get a Quote" text
      const isGetQuoteButton =
        textContent === "Get a Quote" ||
        textContent.includes("Get a Quote");

      // Also check for get-quote-btn ID
      const hasGetQuoteId =
        target.id === "get-quote-btn" ||
        elementToCheck.id === "get-quote-btn" ||
        target.closest("#get-quote-btn");

      if (isGetQuoteButton || hasGetQuoteId) {
        e.preventDefault(); // Prevent default link behavior
        e.stopPropagation();
        showPopup();
      }
    });

    // Close popup handlers
    popupClose?.addEventListener("click", hidePopup);

    popup.addEventListener("click", function (e) {
      if (e.target === popup) hidePopup();
    });

    // Disabled auto-popup - now handled by React component
    // setTimeout(showPopup, 5000);
  }

  // ======= Accordion =======
  const accordionButtons = document.querySelectorAll(".accordion button");

  accordionButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const isExpanded = this.getAttribute("aria-expanded") === "true";
      accordionButtons.forEach((btn) =>
        btn.setAttribute("aria-expanded", "false")
      );
      if (!isExpanded) this.setAttribute("aria-expanded", "true");
    });
  });

  // ======= Swiper =======
  // Note: Blog Swiper is now handled by React in Blog.jsx component
  // This code is kept for backward compatibility but only runs if element exists and not already initialized by React
  const blogSwiper = document.querySelector(".blogSwiper");
  if (blogSwiper && !blogSwiper.swiper) {
    new Swiper(blogSwiper, {
      modules: [Navigation],
      slidesPerView: 3,
      spaceBetween: 24,
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 16 },
        650: { slidesPerView: 2, spaceBetween: 20 },
        900: { slidesPerView: 3, spaceBetween: 28 },
      },
    });
  }
};
